import backendFetch from '../../api/backendFetch';

/**
 * Using mutation to send it as payload oject
 * @param {{
 *  uuid: string,
 * }} payload
 */
const favoriteDatasetFn = async (payload) => {
  const { uuid } = payload;
  const {
    account: { name: organizationName, id: organizationId },
    project: { id: projectId },
  } = window.VSS.getWebContext();

  await backendFetch(`/actionable-agile/api/datasets/${uuid}/star`, {
    method: 'PUT',
    headers: {
      'x-55d-org-id': organizationId,
      'x-55d-org-name': organizationName,
      'x-55d-project-id': projectId,
    },
    bodyOptions: {
      allowEmpty: true,
    },
    body: {},
  });
};

export default favoriteDatasetFn;
